import { usePublicLegalDocument } from '@/hooks/useLegalDocuments';
import LegalDocumentPage from '@/components/legal/LegalDocumentPage';

const TermsOfService = () => {
  const { data: document, isLoading, error } = usePublicLegalDocument('terms_of_service');

  return (
    <LegalDocumentPage
      document={document}
      isLoading={isLoading}
      error={error}
      defaultTitle="Terms of Service"
      defaultContent="Our terms of service information will be available here soon."
    />
  );
};

export default TermsOfService;